import React, { useCallback, ComponentType } from 'react';

import { FilePickerButton } from 'Modules/ui';
import { useAction } from 'Modules/core/redux';
import { useTranslation } from 'Modules/core/i18n';
import { uploadsActions } from 'Modules/business/uploads';

import styles from './index.module.scss';


const ACCEPT_UPLOAD_FILES = [
    '.xls',
    '.xlsx',
    '.xml',
    'text/xml',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
].join(',');

type UploadButtonProps = {
    paginationPath: string;
    processTemplate: string;
    onUpload: () => void;
}

export const UploadButton: ComponentType<UploadButtonProps> = React.memo(({
    paginationPath,
    processTemplate,
    onUpload,
}) => {
    const upload = useAction(uploadsActions.upload);
    const uploadFiles = useCallback(
        files => {
            if (!(files && files.length > 0))
                return;
            onUpload();
            upload({
                query: {
                    processTemplateCode: processTemplate,
                },
                files,
                paginationPath,
            });
        },
        [processTemplate, paginationPath, onUpload, upload],
    );

    const { t } = useTranslation('entitysList');
    return (
        <div className={styles.container}>
            <FilePickerButton
                variant='accent'
                multiple
                accept={ACCEPT_UPLOAD_FILES}
                onPick={uploadFiles}
            >
                {t('buttons.upload')}
            </FilePickerButton>
        </div>
    );
});
